import IconAdvancedView from './IconAdvancedView'

export default IconAdvancedView
